/*eslint camelcase:0, no-underscore-dangle:0*/
import React from "react";
import Marty from "marty";
import assign from "object-assign";
import ValidatedInput from "../../../../utils/components/ValidatedInput";
import ValidatedForm from "../../../../utils/components/ValidatedForm";
import { store } from "../../../../config/config.js";
import Logo from "../../../../utils/components/Logo";
import SubmitButton from "../../../../utils/components/SubmitButton";
import { MONTHS, STATES } from "../../../../utils/constants";

const monthSelectProps = {
        options: MONTHS.map((month, i) => {
            return {value: (i + 1).toString(), label: month.abbreviation};
        }),
        searchable: true,
        clearable: false
    },
    stateSelectProps = {
        options: STATES.map((state) => {
            return {value: state.abbreviation, label: state.abbreviation};
        }),
        searchable: true,
        clearable: false
    };

let Gateway = React.createClass({
    componentWillMount() {
        this.app.navActions.hideBuyButton();
        this.app.navActions.hideHeader();
        this.app.navActions.hideFooter();
    },
    componentWillUnmount() {
        this.app.navActions.showBuyButton();
        this.app.navActions.showHeader();
        this.app.navActions.showFooter();
    },
    componentDidMount() {
        document.title = "eero Store - Payment";
    },
    getInitialState() {
        let defaultAddress = {
            name: `${this.props.data.x_customer_first_name} ${this.props.data.x_customer_last_name}`,
            address_line1: this.props.data.x_customer_shipping_address1,
            address_line2: this.props.data.x_customer_shipping_address2,
            address_city: this.props.data.x_customer_shipping_city,
            address_state: this.props.data.x_customer_shipping_state,
            address_zip: this.props.data.x_customer_shipping_zip
        };

        return {
            creditFormData: assign({}, defaultAddress),
            useAddress: true,
            address: assign({}, defaultAddress)
        };
    },
    toggleAddress(){
        let addressNames = ["name", "address_line1", "address_line2", "address_city", "address_state", "address_zip"];

        if (this.state.useAddress) {
            this.setState({
                useAddress: false
            });
            addressNames.forEach(ref => this.refs.form.refs.innerComponent.refs[ref].setValue());
        } else {
            this.setState({
                useAddress: true
            });
            addressNames.forEach(ref => this.refs.form.refs.innerComponent.refs[ref].setValue(this.state.address[ref]));
        }
    },
    handleCCFormSubmit(cardData, reset, invalidate){
        let customerData = {
                email: this.props.data.x_customer_email,
                metadata: {
                    shopifyReference: this.props.data.x_reference
                }
            },
            shopifyData = {
                x_account_id: this.props.data.x_account_id,
                x_reference: this.props.data.x_reference,
                x_currency: this.props.data.x_currency,
                x_test: this.props.data.x_test,
                x_amount: this.props.data.x_amount
            },
            urls = {
                complete: this.props.data.x_url_complete,
                callback: this.props.data.x_url_callback,
                cancel: this.props.data.x_url_cancel
            };

        this.app.gatewayActions.charge({cardData, customerData, shopifyData, urls}, reset, invalidate);
    },
    render() {
        let splitIndex = this.props.data.x_url_complete ? this.props.data.x_url_complete.indexOf("/offsite_gateway_callback") : -1,
            backUrl = splitIndex > -1 ? `${this.props.data.x_url_complete.substring(0, splitIndex)}?step=shipping_method` : null;

        return (
            <div className="eo-view gateway grid-10 parent">
                <header className="eo-header">
                    <a className="eo-header-link" href={this.props.data.x_url_cancel}>
                        <Logo className="eo-header-logo"/>
                    </a>
                </header>
                <aside className="grid-3 grid-s-10 parent eo-summary float-right">
                    <div className="grid-10">
                        <p className="float-left total-title">Total</p>

                        <p className="float-right total-text">$ {this.props.data.x_amount}</p>
                    </div>
                    <div className="float-left">
                        <a href={`${store.shopify.url}cart`} className="eo-btn-submit gray outline fill edit-cart-btn">Edit Cart</a>
                    </div>
                </aside>
                <main className="eo-main grid-7 grid-s-10 parent float-right">
                    <section className="grid-10 parent clear">
                        <ValidatedForm ref="form" className="grid-10 parent" data={this.state.creditFormData}
                                       handleSubmit={this.handleCCFormSubmit}>
                            <div className="grid-10 grid-l-4 grid-xl-5 parent shipping-info">
                                <h3 className="eo-store-header grid-10">Shipping address</h3>

                                <div className="default-address grid-10">
                                    <p className="name">{`${this.props.data.x_customer_first_name} ${this.props.data.x_customer_last_name}`}</p>

                                    <p className="address">{this.props.data.x_customer_shipping_address1}</p>
                                    {this.props.data.x_customer_shipping_address2 ?
                                        <p className="address">{this.props.data.x_customer_shipping_address2}</p> : null }
                                    <p className="address">{`${this.props.data.x_customer_shipping_city}, ${this.props.data.x_customer_shipping_state} ${this.props.data.x_customer_shipping_zip}`}</p>
                                </div>
                                <div className="float-left">
                                    <a href={backUrl} className="eo-btn-submit gray outline fill edit-shipping-btn">Edit Shipping</a>
                                </div>
                            </div>
                            <div className="grid-10 grid-l-6 grid-xl-5 parent billing-info">
                                <h3 className="eo-store-header grid-10">Billing address</h3>
                                { this.state.useAddress ? (
                                    <div className="default-address grid-10">
                                        <p className="name">{`${this.props.data.x_customer_first_name} ${this.props.data.x_customer_last_name}`}</p>

                                        <p className="address">{this.props.data.x_customer_shipping_address1}</p>
                                        {this.props.data.x_customer_shipping_address2 ?
                                            <p className="address">{this.props.data.x_customer_shipping_address2}</p> : null }
                                        <p className="address">{`${this.props.data.x_customer_shipping_city}, ${this.props.data.x_customer_shipping_state} ${this.props.data.x_customer_shipping_zip}`}</p>
                                    </div>
                                ) : null }
                                <ValidatedInput
                                    placeholder="Full Name"
                                    name="name"
                                    value={this.state.creditFormData.name}
                                    className={["grid-10", (this.state.useAddress ? "hidden" : null)].join(" ")}
                                    type={ this.state.useAddress ? "hidden" : "text" }
                                    required/>
                                <ValidatedInput
                                    placeholder="Street Address"
                                    name="address_line1"
                                    value={this.state.creditFormData.address_line1}
                                    className={["grid-7 grid-s-10", (this.state.useAddress ? "hidden" : null)].join(" ")}
                                    type={ this.state.useAddress ? "hidden" : "text" }
                                    required/>
                                <ValidatedInput
                                    placeholder="Apt, Suite, etc."
                                    name="address_line2"
                                    value={this.state.creditFormData.address_line2}
                                    className={["grid-3 grid-s-10", (this.state.useAddress ? "hidden" : null)].join(" ")}
                                    type={ this.state.useAddress ? "hidden" : "text" }/>
                                <ValidatedInput
                                    placeholder="City"
                                    name="address_city"
                                    value={this.state.creditFormData.address_city}
                                    className={["grid-6 grid-s-10", (this.state.useAddress ? "hidden" : null)].join(" ")}
                                    type={ this.state.useAddress ? "hidden" : "text" }
                                    required/>
                                <ValidatedInput
                                    placeholder="State"
                                    name="address_state"
                                    value={this.state.creditFormData.address_state}
                                    className={["grid-2 grid-s-5", (this.state.useAddress ? "hidden" : null)].join(" ")}
                                    type={ this.state.useAddress ? "hidden" : "select" }
                                    selectProps={stateSelectProps}
                                    required/>
                                <ValidatedInput
                                    placeholder="Zip"
                                    name="address_zip"
                                    value={this.state.creditFormData.address_zip}
                                    className={["grid-2 grid-s-5", (this.state.useAddress ? "hidden" : null)].join(" ")}
                                    type={ this.state.useAddress ? "hidden" : "text" }
                                    required/>

                                <div className="float-left">
                                    <span onClick={this.toggleAddress} className={["change-address-btn eo-btn-submit outline fill gray"].join(" ")}>{this.state.useAddress ? null :
                                        <span className="icon eo-icon-arrow-left"/>} {this.state.useAddress ? "Edit Billing" : "Use shipping address"}</span>
                                </div>
                            </div>
                            <h3 className="grid-10 eo-store-header payment-info">Payment information</h3>
                            <ValidatedInput
                                placeholder="Credit Card Number"
                                name="number"
                                className="grid-10"
                                validations="isValidCreditCard"
                                validationError="Invalid Credit Card Number"
                                required/>
                            <ValidatedInput
                                placeholder="Month"
                                name="exp_month"
                                className="grid-4 grid-s-5"
                                type="select"
                                selectProps={monthSelectProps}
                                required/>
                            <ValidatedInput
                                placeholder="YYYY"
                                name="exp_year"
                                className="grid-3 grid-s-5"
                                validations="isValidExpiry"
                                validationError="Invalid Date"
                                required/>
                            <ValidatedInput
                                placeholder="CVC"
                                name="cvc"
                                className="grid-3 grid-s-5"
                                validations="isValidCVC"
                                validationError="Invalid Code"
                                required/>
                            <SubmitButton className="grid-4 grid-s-10 clear-right finished" text="Complete Order" submittingText="Completing"/>
                        </ValidatedForm>
                    </section>
                </main>
            </div>
        );
    }
});

export default Marty.createContainer(Gateway, {
    listenTo: ["gatewayStore"],
    fetch: {
        data() {
            return this.app.gatewayStore.fetch();
        }
    }
});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/gateway/Handler.js
 **/